import postMessage from "./PostMessage";
import { getModuleApiBase } from "./config";

function prodDataInject(iframe, ab, params, moduleDataId) {
  return new Promise((resolve, reject) => {
    //add storage, after load data inject module code
    var moduleData = function(access_token, instanceId, moduleDataId, accountId, moduleId, initialData, env='production', moduleApiBase) {
      var moduleData = initialData || {};
      var moduleDataID = "module" + instanceId;
      var moduleDataID2 = moduleDataId;

      var resolvedModuleApiBase = moduleApiBase || "https://modules-api.poc.abtastylab.com";

      var doApiCall = function(url, methode, data, callback, env="production") {
        var xhttp = new XMLHttpRequest();
        var apikey = access_token;

        xhttp.open(methode, url, true);
        xhttp.setRequestHeader("Content-type", "application/json");
        xhttp.setRequestHeader("X-ABTasty-Token", apikey);
        xhttp.setRequestHeader("X-ABTasty-Account", accountId);
        xhttp.setRequestHeader("X-ABTasty-Environment", env);

        xhttp.onreadystatechange = function(evt) {
          var xhttp = evt.target;
          if (xhttp.readyState !== 4) return;
          var resp = {};
          if (xhttp.responseText) resp = JSON.parse(xhttp.responseText);

          callback && callback(resp);
        };
        var params = null;
        if (data) params = JSON.stringify(data);
        xhttp.send(params);
      };

      var getAll = function(callback) {
        var getAllCallback = function(data) {
          moduleData = JSON.parse(data.config);
          moduleDataID2 = data.id;

          callback && callback();
        };
        doApiCall(
          `${resolvedModuleApiBase}/accounts/${accountId}/modules/${moduleId}/instances/${instanceId}`,
          "GET",
          null,
          getAllCallback,
          env
        );
      };

      var patchData = function(callback) {
        function patchCallback() {
          getAll(callback);
        }
        doApiCall(
          `${resolvedModuleApiBase}/accounts/${accountId}/modules/${moduleId}/instances/${instanceId}`,
          "PATCH",
          { config: moduleData },
          patchCallback,
          env
        );
      };

      return {
        get: function(key, callback) {
          return callback(moduleData[key]);
        },
        set: function(key, value, callback) {
          moduleData[key] = value;
          patchData(callback);
        }
      };
    };

    var moduleDataStr = moduleData.toString();
    const resolvedModuleApiBase = getModuleApiBase();
    postMessage(
      iframe,
      "evalCode",
      `_ab.storage = (${moduleDataStr})("${ab.accessToken}" ,${ab.instanceId}, ${moduleDataId}, ${ab.accountId}, ${ab.moduleId}, ${JSON.stringify(params)}, '${ab.env || 'production'}', '${resolvedModuleApiBase}')`,
      ab.targetOrigin || "*"
    );
    resolve();
  });
}

function devDataInject(frame, ab, callback) {
  return new Promise((resolve, reject) => {
    function moduleData(moduleID, accessToken, params, onLoadCallback) {
      const data = params || {};
      if (onLoadCallback) onLoadCallback();
      return {
        data: params,
        get: function(key, callback) {
          callback && callback(data[key]);
        },
        set: function(key, value, callback) {
          data[key] = value;
          window.parent.postMessage(
            JSON.stringify({
              action: "setStorage",
              key: key,
              value: value
            }),
            (window._ab && window._ab.targetOrigin) || "*"
          );
          callback && callback(key, value);
        }
      };
    }
    const moduleDataStr = moduleData.toString();
    const codeToInject = `_ab.storage = (${moduleDataStr})(${0},"${
      ab.accessToken
    }", ${JSON.stringify(ab.initialData)})`;
    postMessage(frame, "evalCode", codeToInject, ab.targetOrigin || "*");
    resolve();
  });
}

export default {
  prodDataInject,
  devDataInject
};
